"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cardTextStyles2 = exports.cardTextStyles1 = exports.cardStyles = void 0;
var cardStyles = exports.cardStyles = function cardStyles(_ref) {
  var _ref$isShowing = _ref.isShowing,
    isShowing = _ref$isShowing === void 0 ? false : _ref$isShowing;
  return {
    position: 'absolute',
    bottom: '12.5%',
    left: '10px',
    backgroundColor: 'rgba(23,35,34,0.75)',
    padding: '12px 15px',
    color: '#ffffff',
    width: '320px',
    maxWidth: '70%',
    display: isShowing ? 'block' : 'none',
    borderRadius: '5px'
  };
};
var cardTextStyles1 = exports.cardTextStyles1 = {
  fontSize: '14px',
  fontWeight: 300,
  marginBottom: '5px',
  color: 'rgba(255, 255, 255, 0.75)'
};
var cardTextStyles2 = exports.cardTextStyles2 = {
  fontSize: '20px'
};
var _default = exports.default = {
  cardStyles: cardStyles
};